import React from "react";

const CustomModal = ({open,handleOpenModal,header,children,size = "md",backClick,refrencePage,sentBtnClick}) => {
  if (!open) return null;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/60 px-3"
      id="custom-modal-container"
    >
      {/* MODAL BOX */}
      <div  className={`w-full ${sizeClasses[size]} bg-white rounded-lg shadow-xl flex flex-col`}>
        {/* HEADER */}
        <div className="bg-[#720C20] rounded-t-lg px-3 py-2 sm:px-4 sm:py-3">
          <div className="flex items-center justify-between w-full">
            {/* BACK BUTTON */}


            {/* TITLE */}
            <p
              className={`flex-1 text-center font-semibold ${
                refrencePage === "AgentPreview" ||
                refrencePage === "AgentInformation"
                  ? "text-white text-[18px]"
                  : "text-white"
              }`}
            >
              {header}
            </p>

            {/* CLOSE ICON */}
            <img
              src ="/whiteCrossIcon.svg"
              alt="close"
              onClick={() => handleOpenModal(false)}
              className="w-3 cursor-pointer"
            />
          </div>
        </div>

        {/* BODY */}
        <div className="flex-1 p-3 sm:p-4 overflow-y-auto max-h-[80vh] sm:max-h-[70vh]">
          {children}
        </div>

        {/* FOOTER */}
        {(
            <div className="border-t px-3 py-3 sm:px-4 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
              <button
                onClick={() => handleOpenModal(false)}
                className="w-full sm:w-auto px-4 py-2 rounded-md border border-gray-300 text-sm hover:bg-gray-100"
              >
                {refrencePage === "AgentInformation" ? "Close" : "Cancel"}
              </button>

              {refrencePage !== "AgentInformation" && (
                <button
                  onClick={() => sentBtnClick?.()}
                  className="w-full sm:w-auto px-4 py-2 rounded-md bg-[#720C20] text-white text-sm hover:opacity-90"
                >
                  Send
                </button>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

export default CustomModal;
